import angularReactSelectorDirective from './angularReactSelectorDirective';

// Workaround helper for registering a directive with modules to avoid dependency cycles
// Example: importing supportModule directly in angularReactSelectorDirective causes a dependency cycle since we need angularReactSelectorDirective in the support (root) module
export default function registerDirectives(module) {
  module.directive('shouldRenderAngularComponents', angularReactSelectorDirective);
}
